import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Box,
    Button,
    Container,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography,
} from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AnchorIcon from '@mui/icons-material/Anchor';
import DescriptionIcon from '@mui/icons-material/Description';
import NoteAdd from '@mui/icons-material/NoteAdd';
import CloudUpload from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import baseURL from '../../config';
import bgImage from '../../assets/shipimage.jpg';

const formatDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
};

const AddVessel = () => {
    const { id } = useParams()
    // const userId = localStorage.getItem("user id");


    const [formData, setFormData] = useState({
        company_name: id,
        vesselOwnerId: id,
        creatorTypeId: id,
        creatorRole: 'VesselOwner',
        CharteredOrCrewing: 'Crewinng',
        vesselname: '',
        IMO_Number: '',
        call_sign: '',
        gross_tonage: '',
        vesseltype: '',
        Flag: '',
        pipolicynumber: '',
        policydateofv: '',
        pipolicydocument: null,
        mlcCert: '',
        mlcIssueDate: '',
        mlcExpiryDate: '',
        maritimelabourconvention: null,
        fsdnumber: '',
        fsdvalidity: '',
        fsdocument: null,
        dmlcp1: null,
        dmlc2: null,
        kiloWatt: '',
        bhp: '',
    });


    const [selectedUnit, setSelectedUnit] = useState('kiloWatt');
    const vesselID = null; // Or populate if in edit mode


    const FileUploadField = ({ label, name, file }) => (
        <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2, mt: 2 }}>
            <Typography variant="body1" sx={{ mb: 1 }}>{label}</Typography>
            <Button
                component="label"
                variant="outlined"
                startIcon={<CloudUpload />}
            >
                Upload File
                <VisuallyHiddenInput
                    type="file"
                    name={name}
                    onChange={handleFileChange}
                />
            </Button>
            <Typography variant="caption" sx={{ ml: 2 }}>
                {file?.originalName || "No file selected"}
            </Typography>
        </Box>
    );

    const VisuallyHiddenInput = styled("input")({
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: 1,
        overflow: "hidden",
        position: "absolute",
        bottom: 0,
        left: 0,
        whiteSpace: "nowrap",
        width: 1,
    });


    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                [name]: {
                    originalName: files[0].name, // Store the file's name
                    file: files[0], // Store the actual file object
                },
            }));
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleUnitChange = (e) => {
        setSelectedUnit(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const FormDataToSend = new FormData();

        // Ensure only selected power unit is included by modifying formData
        const formDataToSend = { ...formData }; // Copy the formData to preserve original

        if (selectedUnit === "kiloWatt") {
            delete formDataToSend.bhp;
        } else if (selectedUnit === "bhp") {
            delete formDataToSend.kiloWatt;
        }

        // Append regular fields to the FormData object
        for (const [key, value] of Object.entries(formDataToSend)) {
            if (value !== null && value !== undefined) {
                if (value.file) {
                    FormDataToSend.append(key, value.file); // For file fields
                } else {
                    FormDataToSend.append(key, value); // For regular fields
                }
            }
        }

        // Retrieve token from localStorage
        const token = localStorage.getItem("token");

        if (!token) {
            toast.error("Authorization token not found!");
            return;
        }

        try {
            const response = await axios.post(`${baseURL}/api/vesselform`, FormDataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`, // Token included
                },
            });

            toast.success('Vessel submitted successfully!');
            // console.log('Response:', response.data);
        } catch (error) {
            toast.error(error.response.data.message);
            console.error('Error:', error);
        }
    };

    return (
        <>

            <ToastContainer />
            <Container
                sx={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 6,
                    px: 2,
                }}>
                <div elevation={4} sx={{ p: 1, borderRadius: 3, bgcolor: 'grey.100' }}>
                    <Box sx={{ textAlign: 'center', mb: 1 }}>
                        <AnchorIcon sx={{ fontSize: 50, color: '#d32f2f' }} />
                        <Typography variant="h4" gutterBottom>
                            Vessel Registration
                        </Typography>
                        <Typography variant="subtitle1" color="text.secondary">
                            Fill in the details below to register your vessel
                        </Typography>
                    </Box>

                    <form onSubmit={handleSubmit}>
                        {/* Ship Info */}
                        <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 3 }}>
                            <Typography variant="h5" gutterBottom sx={{ mb: 3, color: '#C30B12' }}>
                                <DescriptionIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                                Ship Information
                            </Typography>
                            <Grid container spacing={3} sx={{ display: 'none' }}>
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Crewing</InputLabel>
                                        <Select
                                            name="CharteredOrCrewing"
                                            value="Crewing"
                                            label="Chartered or Crewing"
                                            readOnly
                                            disabled
                                        >
                                            <MenuItem value="Crewing">Crewing</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container spacing={3}>
                                {[
                                    { name: 'vesselname', label: 'Name of Ship' },
                                    { name: 'IMO_Number', label: 'IMO Number' },
                                    { name: 'call_sign', label: 'Call Sign' },
                                    { name: 'gross_tonage', label: 'Gross Tonnage' },
                                    { name: 'vesseltype', label: 'Ship Type' },
                                    { name: 'Flag', label: 'Ship Flag' },
                                ].map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <TextField
                                            fullWidth
                                            name={field.name}
                                            label={field.label}
                                            value={formData[field.name]}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                        <FormControl fullWidth>
                                            <InputLabel>Power Unit</InputLabel>
                                            <Select
                                                value={selectedUnit}
                                                onChange={handleUnitChange}
                                                label="Power Unit"
                                            >
                                                <MenuItem value="kiloWatt">kW (KiloWatt)</MenuItem>
                                                <MenuItem value="bhp">BHP</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            label="Power Value"
                                            value={formData[selectedUnit]}
                                            onChange={(e) =>
                                                setFormData({ ...formData, [selectedUnit]: e.target.value })
                                            }
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>

                        {/* P&I Insurance Section */}
                        <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 3 }}>
                            <Typography variant="h5" gutterBottom sx={{ mb: 3, color: '#C30B12' }}>
                                <NoteAdd sx={{ mr: 1, verticalAlign: 'middle' }} />
                                P&I Insurance Details
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Policy Number"
                                        name="pipolicynumber"
                                        value={formData.pipolicynumber}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        label="Policy Validity Date"
                                        InputLabelProps={{ shrink: true }}
                                        name="policydateofv"
                                        value={formatDate(formData.policydateofv)}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FileUploadField
                                        label="P&I Policy Document"
                                        name="pipolicydocument"
                                        file={formData.pipolicydocument}
                                        onChange={(file) => setFormData({ ...formData, pipolicydocument: file })}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>

                        {/* MLC Section */}
                        <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 3 }}>
                            <Typography variant="h5" gutterBottom sx={{ mb: 3, color: '#C30B12' }}>
                                <NoteAdd sx={{ mr: 1, verticalAlign: 'middle' }} />
                                Maritime Labour Convention (MLC) Details
                            </Typography>

                            <Grid container spacing={3}>
                                {/* Handle MLC Certificate Number as text or number */}
                                {[
                                    { name: 'mlcCert', label: 'MLC Certificate Number', type: 'text' }, // Changed type to text
                                    { name: 'mlcIssueDate', label: 'Issue Date', type: 'date' },
                                    { name: 'mlcExpiryDate', label: 'Expiry Date', type: 'date' },
                                ].map((field) => (
                                    <Grid item xs={12} md={4} key={field.name}>
                                        <TextField
                                            fullWidth
                                            label={field.label}
                                            name={field.name}
                                            type={field.type || 'text'}
                                            InputLabelProps={field.type === 'date' ? { shrink: true } : {}}
                                            value={field.type === 'date' ? formatDate(formData[field.name]) : formData[field.name]} // Handles date formatting and other types
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                ))}

                                <Grid item xs={12}>
                                    <FileUploadField
                                        label="MLC Certificate Document"
                                        name="maritimelabourconvention"
                                        file={formData.maritimelabourconvention}
                                        onChange={(file) =>
                                            setFormData({ ...formData, maritimelabourconvention: file })
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Paper>


                        {/* Financial Security Section */}
                        <Paper elevation={0} sx={{ p: 3, mb: 4, border: 1, borderColor: 'divider' }}>
                            <Typography variant="h5" gutterBottom sx={{ mb: 3, color: '#C30B12' }}>
                                <NoteAdd sx={{ mr: 1, verticalAlign: 'middle' }} />
                                Financial Security Details
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Document Number"
                                        name="fsdnumber"
                                        value={formData.fsdnumber}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Validity Date"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        name="fsdvalidity"
                                        value={formatDate(formData.fsdvalidity)}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FileUploadField
                                        label="Financial Security Document"
                                        name="fsdocument"
                                        file={formData.fsdocument}
                                        onChange={(file) => setFormData({ ...formData, fsdocument: file })}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>

                        {/* DMLC Documents Section */}
                        <Paper elevation={0} sx={{ p: 3, mb: 4, border: 1, borderColor: 'divider' }}>
                            <Typography variant="h5" gutterBottom sx={{ mb: 3, color: '#C30B12' }}>
                                <NoteAdd sx={{ mr: 1, verticalAlign: 'middle' }} />
                                DMLC Documents
                            </Typography>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <FileUploadField
                                        label="DMLC Part 1"
                                        name="dmlcp1"
                                        file={formData.dmlcp1}
                                        onChange={(file) => setFormData({ ...formData, dmlcp1: file })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FileUploadField
                                        label="DMLC Part 2"
                                        name="dmlc2"
                                        file={formData.dmlc2}
                                        onChange={(file) => setFormData({ ...formData, dmlc2: file })}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>

                        {/* Submit Button */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
                            <Button type="submit" variant="contained"  size="large" sx={{ px: 6 , backgroundColor:"red"}}>
                                {vesselID ? 'Update' : 'Submit'}
                            </Button>
                        </Box>
                    </form>
                </div>
            </Container>
        </>
    );
};

export default AddVessel;
